export const shadingRequestScope = (canvasId, designId) => designId || canvasId || null;

export const shadingMatchesScope = (url, leadId, canvasId, designId) => {
  const scopeId = shadingRequestScope(canvasId, designId);
  if (!url || !leadId || !scopeId) return false;
  const paths = [];
  if (canvasId && String(scopeId) !== String(canvasId)) {
    paths.push(`/${leadId}/${canvasId}/${scopeId}`);
    paths.push(`/${leadId}/${canvasId}`);
    if (String(canvasId) === String(leadId)) paths.push(`/${leadId}`);
  } else if (String(scopeId) === String(leadId)) {
    paths.push(`/${leadId}`);
  } else {
    paths.push(`/${leadId}/${scopeId}`);
  }
  const pathname = String(url).trim().split(/[?#]/)[0];
  return paths.some(
    (scopePath) => pathname.endsWith(`${scopePath}/shadings.json`) || pathname.endsWith(`${scopePath}/shadings.latest.json`)
  );
};
